export default __webpack_public_path__ + "static/media/studio.94ab1c7e.jpg";